

export default {
    id:"usePinchGesture",
    type:"(options:object):void",
    options:[
        {
            name:"element",
            type:"HTMLElement",
        },
        {
            name:"minPointerCount",
            type:"number",
            description:`
                Minimum number of pointers that triggers the pinch gesture
                @minimum possible value : 2
                @default: 2
            `,
        },
        {
            name:"maxPointerCount",
            type:"number",
            description:`
                Maximum number of pointers for the pinch gesture.
                @If the number of pointers is higher, the gesture is ended
                @Minimum possible value : 2
                @default: Infinity
            `,
        },
        ...["onStart","onMove","onEnd"].map((name,i,{length})=>({
            name,
            type:"(event:PinchEvent):void",
            props:((i+1)===length)&&[
                {
                    name:"PinchEvent",
                    type:"TouchEvent",
                    props:[
                        ...["scale","dx","dy","distance"].map(name=>({name,type:"number"})),
                        {
                            name:"dtime",
                            type:"number",
                            description:"Gesture delta time in milliseconds",
                        },
                        {
                            name:"barycenter",
                            type:"object",
                            props:["x","y"].map(name=>({name,type:"number"})),
                        },
                    ],
                }
            ],
        })),
    ],
};
